/**
 * Given an object, returns a new object with the keys sorted.
 */
export function sortObjectKeys<TObject extends Record<string, unknown>>(object: TObject): TObject {
  const sortedObject: Partial<TObject> = {};

  for (const key of Object.keys(object).sort() as (keyof TObject)[]) {
    sortedObject[key] = object[key];
  }

  return sortedObject as TObject;
}
